import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/outsourced/payroll/config/page.tsx");
